import apiClient from '../../../api/client';
import type {
  ServicioResponse,
  ServicioStatsResponse,
  CreateServicioDto,
  UpdateServicioDto,
  QueryServiciosDto,
  Paginated,
} from '@aid/shared';

export type {
  ServicioResponse,
  ServicioStatsResponse,
  CreateServicioDto,
  UpdateServicioDto,
  QueryServiciosDto,
};

export async function getServicios(
  params: QueryServiciosDto,
): Promise<Paginated<ServicioResponse>> {
  const { data } = await apiClient.get<Paginated<ServicioResponse>>('/admin/servicios', { params });
  return data;
}

export async function getServiciosStats(
  params: Omit<QueryServiciosDto, 'offset' | 'limit'>,
): Promise<ServicioStatsResponse> {
  const { data } = await apiClient.get<ServicioStatsResponse>('/admin/servicios/stats', { params });
  return data;
}

export async function getServicio(id: number): Promise<ServicioResponse> {
  const { data } = await apiClient.get<ServicioResponse>(`/admin/servicios/${id}`);
  return data;
}

export async function createServicio(dto: CreateServicioDto): Promise<ServicioResponse> {
  const { data } = await apiClient.post<ServicioResponse>('/admin/servicios', dto);
  return data;
}

export async function updateServicio(
  id: number,
  dto: UpdateServicioDto,
): Promise<ServicioResponse> {
  const { data } = await apiClient.patch<ServicioResponse>(`/admin/servicios/${id}`, dto);
  return data;
}
